// 9fbef606107a605d69c0edbcd8029e5d
import { call, put, takeLatest, select } from 'redux-saga/effects';
import logger from '@tcp/core/src/utils/loggerInstance';
import { getAPIConfig } from '@tcp/core/src/utils';
import {
  getIsStoreInventoryApi,
  getModalBopisStoreCount,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import PRODUCT_PICKUP_ACTIONS_CONSTANTS from '../ProductPickup.constants';
import {
  setBopisInventoryDetailsAction,
  fromAvailableStoresClick,
  setRecommendationsBopisInventoryDetailsAction,
  getStoreSpecificInventorySuccessAction,
} from './ProductPickup.actions';
import getBopisInventoryDetails from '../../../../../services/abstractors/common/bopisInventory/bopisInventory';
import { getAllBopisStores } from '../../PickupStoreModal/container/PickUpStoreModal.selectors';
import { filterAvailableStores } from '../util';
import {
  setNearestAvailableStoreActn,
  setBopisStores,
  setRecommendationNearestAvailableStoreActn,
} from '../../PickupStoreModal/container/PickUpStoreModal.actions';
import { getStoreSpecificInventory } from '../../../../../services/abstractors/productListing/productDetail';
import { getUnbxdXappConfigs } from '../../../../features/browse/ProductListing/container/ProductListing.saga';

const CheckStoreIdNull = (param) => {
  let payload = param;
  if (Array.isArray(param)) {
    payload = {
      storeIds: param.filter((item) => item.storeId),
    };
    return payload.storeIds.length > 0;
  }
  return payload?.storeId;
};

export function* storeSpecificInventory({ payload }) {
  const xappURLConfig = yield call(getUnbxdXappConfigs);

  const apiConfig = getAPIConfig();

  const { unbxdUrl, unbxdSiteKey, unbxdApiKey } = apiConfig;
  const originalURL = `${unbxdUrl}/${unbxdApiKey}/${unbxdSiteKey}`;
  const { storeId, productId, brand } = payload;
  const inventoryResponse = yield call(getStoreSpecificInventory, {
    productId,
    brand,
    storeId,
    xappURLConfig,
    originalURL,
    apiConfig,
  });

  if (inventoryResponse) {
    yield put(getStoreSpecificInventorySuccessAction(inventoryResponse));
  }
}

export function* getBopisInventory({ payload }) {
  yield put(setRecommendationsBopisInventoryDetailsAction({}));
  try {
    const { itemInfo, isMultiStoreEnabled, isRecommendationsQV, requestedQuantity } = payload;
    if (!isRecommendationsQV) {
      yield put(setBopisInventoryDetailsAction({}));
    }
    if (CheckStoreIdNull(itemInfo)) {
      const isStoreInventoryApiEnabled = yield select(getIsStoreInventoryApi);
      const inventoryResponse = yield call(
        getBopisInventoryDetails,
        itemInfo,
        [],
        isStoreInventoryApiEnabled,
        isMultiStoreEnabled
      );
      if (isMultiStoreEnabled) {
        const allBopisStores = yield select(getAllBopisStores);
        const storecount = yield select(getModalBopisStoreCount);
        yield put(fromAvailableStoresClick(true));
        if (isRecommendationsQV) {
          yield put(
            setRecommendationNearestAvailableStoreActn(
              filterAvailableStores(
                inventoryResponse,
                allBopisStores,
                storecount,
                requestedQuantity
              )
            )
          );
          yield put(setRecommendationsBopisInventoryDetailsAction({ inventoryResponse }));
        } else {
          yield put(
            setBopisStores({
              stores: filterAvailableStores(
                inventoryResponse,
                allBopisStores,
                storecount,
                requestedQuantity
              ),
            })
          );
          yield put(
            setNearestAvailableStoreActn(
              filterAvailableStores(
                inventoryResponse,
                allBopisStores,
                storecount,
                requestedQuantity
              )
            )
          );
          yield put(setBopisInventoryDetailsAction({ inventoryResponse }));
        }
      } else {
        yield put(setBopisInventoryDetailsAction({ inventoryResponse }));
      }
    }
  } catch (err) {
    logger.error({
      error: err,
      extraData: {
        component: 'ProductPickUp Saga - getBopisInventory',
        payloadRecieved: payload,
      },
    });
  }
}

function* ProductPickupStoreSaga() {
  yield takeLatest(PRODUCT_PICKUP_ACTIONS_CONSTANTS.GET_BOPIS_INVENTORY, getBopisInventory);
  yield takeLatest(
    PRODUCT_PICKUP_ACTIONS_CONSTANTS.GET_STORE_SPECIFIC_INVENTORY,
    storeSpecificInventory
  );
}

export default ProductPickupStoreSaga;
